import { useLocation, useNavigate } from 'react-router-dom';
import {
  goToRoute,
  goToPreviousPage,
  goToNextPage,
  goToMovesIndex,
  goToLanesIndex,
  goToLocationsIndex,
  goToLocationDetails,
  goToMovePlanner,
  goToMoveDetails,
  goToInvoice,
  goToUserDetails,
} from '@services/navigationService';
import {
  condensedCase,
  capFirst,
  capEach,
  capAll,
  round,
  checkNeg,
  getMonetaryValue,
  getCleansedMonetaryValue,
  getCleansedPhoneNumber,
  clampNegNum,
} from '@services/formatService';
import {
  getFormattedRidesharePartner,
  getFormattedCombinedStatusFromMove,
  getFormattedStatusFromDrive,
  getFormattedCancelStatusFromDrive,
  getFormattedStatusFromRide,
  getFormattedStatusFromPlan,
  getFormattedStatusFromHangtag,
} from '@services/statusService';
import {
  getFormattedVehicleFromMove,
  checkMoveInProgress,
  checkMoveCompleted,
  getLatestTimestampFromMove,
  getDriverInitialsFromMove,
  getPickupOrDeliveryTimeFromMove,
} from '@services/moveService';
import {
  getFormattedTypeFromLocation,
  getLocationByIdFromList,
  getPendingAccessorial,
  getNameFromLocation,
  getDriveTypeFromMove,
} from '@services/locationService';
import { durationBetween, getDurationInMinutes, getMinutesBetween } from '@services/timeService';
import {
  getLastNDigits,
  getReadableText,
  getSnakeCase,
  getNonBreakingWord,
  getWorkflowData,
  getCancelHeaderFromMove,
  getCancelReasonFromMove,
  copyToClipboard,
  circularJSONStringify,
  getFirstNameFromDisplayName,
  getMiddleNameFromDisplayName,
  getLastNameFromDisplayName,
  getUserName,
  getInitialsFromName,
} from '@services/utilityService';

export function useTools() {
  const navigate = useNavigate();
  // The embed's configuration rides the query string, so every navigation carries it.
  const { search } = useLocation();

  return {
    goToRoute: (route: string | null = null) => goToRoute(route, navigate, search),
    goToPreviousPage: () => goToPreviousPage(navigate),
    goToNextPage: () => goToNextPage(navigate),
    goToMovesIndex: () => goToMovesIndex(navigate, search),
    goToLanesIndex: () => goToLanesIndex(navigate, search),
    goToLocationsIndex: () => goToLocationsIndex(navigate, search),
    goToLocationDetails: (locationId: number) => goToLocationDetails(navigate, locationId, search),
    goToMovePlanner: () => goToMovePlanner(navigate, search),
    goToMoveDetails: (moveId: string | null  = null, edit = false) => goToMoveDetails(moveId, edit, navigate, search),
    goToInvoice: (invoiceId = null, customerId = null, foldId = null) =>
    goToInvoice(invoiceId, customerId, foldId, navigate, search),
    goToUserDetails: (userId = null) => goToUserDetails(userId, navigate, search),
    condensedCase,
    capFirst,
    capEach,
    capAll,
    round,
    checkNeg,
    getFormattedRidesharePartner,
    getFormattedCombinedStatusFromMove,
    getFormattedStatusFromDrive,
    getFormattedCancelStatusFromDrive,
    getFormattedStatusFromRide,
    getFormattedStatusFromPlan,
    getFormattedStatusFromHangtag,
    getFormattedVehicleFromMove,
    getInitialsFromName,
    checkMoveInProgress,
    checkMoveCompleted,
    getLatestTimestampFromMove,
    getDriverInitialsFromMove,
    getPickupOrDeliveryTimeFromMove,
    getFormattedTypeFromLocation,
    getLocationByIdFromList,
    getPendingAccessorial,
    getNameFromLocation,
    getDriveTypeFromMove,
    durationBetween,
    getDurationInMinutes,
    getMinutesBetween,
    getLastNDigits,
    getReadableText,
    getSnakeCase,
    getCleansedPhoneNumber,
    getNonBreakingWord,
    getWorkflowData,
    getCancelHeaderFromMove,
    getCancelReasonFromMove,
    copyToClipboard,
    circularJSONStringify,
    getFirstNameFromDisplayName,
    getMiddleNameFromDisplayName,
    getLastNameFromDisplayName,
    getUserName,
    getMonetaryValue,
    getCleansedMonetaryValue,
    clampNegNum,
  };
}
